// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/app/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import FileTextOutlined from '/app/node_modules/@ant-design/icons/es/icons/FileTextOutlined';
import SmileOutlined from '/app/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import ProfileOutlined from '/app/node_modules/@ant-design/icons/es/icons/ProfileOutlined';
import NotificationOutlined from '/app/node_modules/@ant-design/icons/es/icons/NotificationOutlined';
import PictureOutlined from '/app/node_modules/@ant-design/icons/es/icons/PictureOutlined';
import MessageOutlined from '/app/node_modules/@ant-design/icons/es/icons/MessageOutlined';
export default { DashboardOutlined, FileTextOutlined, SmileOutlined, ProfileOutlined, NotificationOutlined, PictureOutlined, MessageOutlined };
